// extracted by mini-css-extract-plugin
export default {"editCompanyCardPage":"EditCompanyCardPage_editCompanyCardPage__IYHvh","content":"EditCompanyCardPage_content__gAmhT","deleteBtn":"EditCompanyCardPage_deleteBtn__YuGPR"};